import { getID } from "src/libs/utilities";
import { ALIGN, LANDING_TYPE_CONTENT, WriterType } from "../interfaces";

export default function writer(): any[] {
    return [
        {
            id: getID("writer"),
            type: LANDING_TYPE_CONTENT.WRITER, 
            writerType: WriterType.PUSHKIN,
            horizontal_align: ALIGN.MIDDLE,
            style : {
                "fontSize": 35,
                "fontFamily": "Great Vibes"
            },
            position: {
                "width": 400
            },
            text: "О сколько нам открытий чудных<br>Готовят просвещенья дух<br>И опыт, сын ошибок трудных,<br>И гений, парадоксов друг,<br>И случай, бог изобретатель…<br>    Александр Сергеевич Пушкин",
            defaultTitle: "Имитация рукописи"
        },
        {
            id: getID("writer"),
            type: LANDING_TYPE_CONTENT.WRITER, 
            writerType: WriterType.SCRAMBLE,
            horizontal_align: ALIGN.MIDDLE, 
            "style": { 
                "fontSize": 35,
            },
            "text": "Тук-тук<br>Проснись, Нео<br>Ты увяз в Матрице<br>Иди за белым кроликом...",
            "defaultTitle": "Neo"
        },
        {
            id: getID("writer"),
            type: LANDING_TYPE_CONTENT.WRITER, 
            writerType: WriterType.JUMPER,
            horizontal_align: ALIGN.MIDDLE, 
            "style": { 
                "textShadow": "rgba(12, 16, 34, 0.7411764706) 1px 1px, rgba(12, 16, 34, 0.7411764706) 2px 2px, rgba(12, 16, 34, 0.7411764706) 3px 3px, rgba(12, 16, 34, 0.7411764706) 4px 4px, rgba(12, 16, 34, 0.7411764706) 5px 5px, rgba(12, 16, 34, 0.7411764706) 6px 6px"
            },
            "text_size": 65,
            "text": "Купите <br>гамбургер <br>немедленно!",
            "defaultTitle": "Jumper",
            "position": { }, 
            "text_color": "var(--orange)",
            "font_weight": 900
        },
        {
            id: getID("writer"),
            type: LANDING_TYPE_CONTENT.WRITER, 
            writerType: WriterType.JUMPER,
            horizontal_align: ALIGN.MIDDLE, 
            "style": {
                "textShadow": "rgba(12, 16, 34, 0.7411764706) 1px 1px, rgba(12, 16, 34, 0.7411764706) 2px 2px, rgba(12, 16, 34, 0.7411764706) 3px 3px, rgba(12, 16, 34, 0.7411764706) 4px 4px, rgba(12, 16, 34, 0.7411764706) 5px 5px, rgba(12, 16, 34, 0.7411764706) 6px 6px"
            },
            "className": "jump-letter-left",
            "text": "Купите <br>гамбургер <br>немедленно!",
            "defaultTitle": "Jumper",
            "position": {},
            "text_color": "var(--yellow)",
            "text_size": 65,
            "font_weight": 900,
            "variant": 1, 
        }
    ]
}